module.exports = __webpack_public_path__ + "media/images/emblems/Oberembrach-blazon-1164723619e808b1bd723cd52e84f25e.svg";